export default __webpack_public_path__ + "static/media/icon-quality-none.c08621ed.svg";